import React from "react";
import { useReveal } from "@/hooks/useReveal";

// Section wrapper with alternating background tones and reveal-on-scroll.
export function Section({ tone = "white", className = "", children, id, ...rest }) {
  const bg =
    tone === "light" ? "bg-nek-light" : tone === "navy" ? "bg-nek-navy text-white" : "bg-white";
  return (
    <section id={id} className={`${bg} py-16 sm:py-24 ${className}`} {...rest}>
      <div className="nek-container">{children}</div>
    </section>
  );
}

export function Reveal({ as: Tag = "div", className = "", style, children, ...rest }) {
  const ref = useReveal();
  const mapped = style && style.animationDelay ? { ...style, transitionDelay: style.animationDelay } : style;
  return (
    <Tag ref={ref} className={`reveal ${className}`} style={mapped} {...rest}>
      {children}
    </Tag>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <span className={`nek-eyebrow ${className}`}>
      {children}
    </span>
  );
}
